var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"w-full h-full"},[_c('Posts')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-between px-10 py-8 bg-gray-100 border-b rounded-t-lg"},[_c('h1',{staticClass:"text-xl font-semibold tracking-wider text-gray-800 uppercase"},[_vm._v(" Posts ")])])
}]

export { render, staticRenderFns }